import { tokens } from './tokens';

// The theme object passed to JSS ThemeProvider via Redux.
// Structured identically to tokens for now, but this is where
// derived values (e.g., color variants, responsive helpers) can be added.
export const defaultTheme = { ...tokens };

export type Theme = typeof defaultTheme;
